import { ref } from 'vue'

export function useSelectedItem() {
  const selectedItem = ref(null)

  const selectItem = (item) => {
    selectedItem.value = item
  }

  const deselectItem = () => {
    selectedItem.value = null
  }

  return {
    selectedItem,
    selectItem,
    deselectItem,
  }
}
